import { Stack } from 'expo-router';

export default function RankingEvalStructureLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
